import React from 'react';
import BookingsTab  from '../admin/BookingsTab';
import CustomersTab from '../admin/CustomersTab';
import PricingTab   from '../admin/PricingTab';
import BoothsTab    from '../admin/BoothsTab';
import PackagesTab  from '../admin/PackagesTab';
import BackdropsTab from '../admin/BackdropsTab';
import ContractsTab from '../admin/ContractsTab';
import AnalyticsTab from '../admin/AnalyticsTab';
import PaymentsTab  from '../admin/PaymentsTab';
import InvoicesTab  from '../admin/InvoicesTab';
import NotificationsTab from '../admin/NotificationsTab';
import RolesTab from '../admin/RolesTab';
import OrganizerHistoryTab from '../admin/OrganizerHistoryTab';

export default function AdminPanel({ tab, setPendingCount, setUnreadNotifications }) {
  const tabMap = {
    bookings:  <BookingsTab setPendingCount={setPendingCount} />,
    customers: <CustomersTab />,
    pricing:   <PricingTab />,
    booths:    <BoothsTab />,
    packages:  <PackagesTab />,
    backdrops: <BackdropsTab />,
    contracts: <ContractsTab />,
    analytics: <AnalyticsTab />,
    payments:  <PaymentsTab />,
    invoices:  <InvoicesTab />,
    notifications: <NotificationsTab setUnreadNotifications={setUnreadNotifications} />,
    roles:      <RolesTab />,
    organizers: <OrganizerHistoryTab />,
  };

  return (
    <div style={{ color: '#fff', fontFamily: 'Arial, Helvetica, sans-serif' }}>
      {tabMap[tab] || <p style={{ color: '#a0a0b8' }}>Select a section from the sidebar.</p>}
    </div>
  );
}
